// extracted by mini-css-extract-plugin
export default {"page":"RichPromotionPage_page__aaiTw","fields":"RichPromotionPage_fields__Lzo6V","upload":"RichPromotionPage_upload__VuMl2"};